import { Card, Image } from "antd";
import { PartsRequestViewModel } from "../../../interfaces";

export const TechAssistance = ({
  partsRequest,
  originalOwner
}: {
  partsRequest: PartsRequestViewModel[];
  originalOwner?: string
}) => {
  return (
    <Card
      className="mb-3"
      title={<p>Assistência Técnica {originalOwner ? <span style={{color: 'black'}}>{` --- Montador de Origem: ${originalOwner}`}</span> : ''}</p>}
      size="small"
      headStyle={{ color: " #1677FF" }}
    >
      {partsRequest.map((item: PartsRequestViewModel) => (
        <div key={item.id} className="w-full">
          <div>
            <h3>Título</h3>
            <p>{item.name}</p>
          </div>
          <div>
            <Card title="Itens" size="small" headStyle={{ color: "#1677FF" }}>
              {item.PartsRequestProduct.map(
                (item: PartsRequestViewModel["PartsRequestProduct"][0]) => (
                  <>
                    <div className="flex w-full -mt-4">
                      <div className="w-1/3">
                        <h3>Nome do Item:</h3>
                        <p>{item.product.description}</p>
                      </div>
                      <div className="w-1/3">
                        <h3>Motivo:</h3>
                        <p>{item.reason}</p>
                      </div>
                      <div className="w-1/3">
                        <h3>Numero da Peça:</h3>
                        <p>{item.partNumber}</p>
                      </div>
                    </div>
                    <div className="flex w-full -mt-4">
                      <Card
                        className="w-full"
                        title="Imagens"
                        size="small"
                        headStyle={{ color: "#1677FF" }}
                      >
                        <div className=" flex w-full gap-10 justify-center">
                          {item.issueImages.map((image) => (
                            <Image width={200} height={200} src={image.url} />
                          ))}
                        </div>
                      </Card>
                    </div>
                  </>
                )
              )}
            </Card>
          </div>
        </div>
      ))}
    </Card>
  );
};
